import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

const SearchResultLoading = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "h-full flex-1 flex items-center justify-center",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-neutral-400" />
      </div>
    </div>
  );
};

export default SearchResultLoading;
